<template>
    <div class="m-formula">
        <div class="m-formula__item--row">
            {{ data.formula }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'formula',
        props: ['data']
    }
</script>



// WEBPACK FOOTER //
// Formula.vue?aca2c0be